import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import Menu from "../sections/Menu";
import Footer from "../sections/Footer";
import AnimatedCounter from "../components/AnimatedCounter";
import { AnalyticsHandle } from "../components/AnalyticsHandle";
import PageMeta from "../seo/PageMeta";
import { buildCollectionPageStructuredData } from "../seo/structuredData";

function CaseStudy() {
  const [content, setContent] = useState(null);
  const { logRegisterClick } = AnalyticsHandle();

  const handleRegisterClick = () => {
    logRegisterClick("case_study_primary");
    window.open("/register", "_self");
  };

  useEffect(() => {
    fetch("/data/content.json")
      .then((res) => res.json())
      .then((data) => setContent(data))
      .catch((error) => console.error("Error loading JSON:", error));
  }, []);

  const collectionStructuredData = useMemo(
    () => [
      buildCollectionPageStructuredData({
        path: "/case-study",
        name: "Case studies eGodziny",
        description: "Historie wdrożeń i efektów biznesowych klientów eGodziny.",
        itemListElements: [
          {
            name: "Case study Staldach-bud",
            url: "/case-study/staldach-bud",
          },
          {
            name: "Case study HR Centre",
            url: "/case-study/hr-centre",
          },
        ],
      }),
    ],
    []
  );

  if (!content) return <div></div>;

  return (
    <>
      <PageMeta path="/case-study" structuredData={collectionStructuredData} />
      <Menu />

      <Container
        className="py-5"
        style={{ paddingTop: "120px", minHeight: "90vh" }}
      >
        <Row className="justify-content-center">
          <Col lg={12} className="px-4">
            <div className="text-center mb-5">
              <h1
                className="mb-4"
                style={{ fontSize: "3rem", fontWeight: "bold" }}
              >
                Case Studies
              </h1>
              <p
                style={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  marginBottom: "40px",
                }}
              >
                Poznaj historie sukcesu naszych klientów
              </p>
            </div>

            {/* Case Study Cards */}
            <Row className="justify-content-center g-4 mb-5">
              {/* Staldach-Bud Case Study */}
              <Col lg={8} md={12}>
                <div
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "20px",
                    padding: "40px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    cursor: "pointer",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 30px rgba(0, 0, 0, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 20px rgba(0, 0, 0, 0.1)";
                  }}
                  onClick={() =>
                    window.open("/case-study/staldach-bud", "_self")
                  }
                >
                  <Row className="align-items-center mb-4">
                    <Col md={4} className="text-center mb-4 mb-md-0">
                      <div style={{ marginBottom: "20px" }}>
                        <Image
                          src={require("../images/staldach-bud-logo.png")}
                          alt="Staldach-Bud Logo"
                          style={{
                            width: "150px",
                            height: "auto",
                          }}
                        />
                      </div>
                      <div style={{ marginTop: "25px", fontSize: "14px" }}>
                        <div
                          style={{ fontWeight: "bold", marginBottom: "5px" }}
                        >
                          Mariusz Wolny
                        </div>
                        <div style={{ color: "#666", marginBottom: "3px" }}>
                          Prezes Zarządu
                        </div>
                        <div style={{ color: "#666" }}>
                          STALDACH-BUD sp. z o.o.
                        </div>
                      </div>
                    </Col>

                    <Col md={8}>
                      <h3
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                          marginBottom: "15px",
                          color: "#1f2937",
                        }}
                      >
                        Jak Staldach-bud sp. z o.o. oszczędza ponad 9 tysięcy
                        złotych miesięcznie
                      </h3>
                      <p
                        style={{
                          fontStyle: "italic",
                          marginBottom: "20px",
                          color: "#333",
                          fontSize: "16px",
                          lineHeight: "1.5",
                        }}
                      >
                        "Jako przedsiębiorca wiecznie przytłoczony ilością zadań
                        i obowiązków, nie zdawałem sobie sprawy, że w tak łatwy
                        sposób można poprawić działanie firmy"
                      </p>
                      <div
                        style={{
                          fontSize: "2rem",
                          fontWeight: "bold",
                          color: "#407EF9",
                          marginBottom: "10px",
                        }}
                      >
                        <AnimatedCounter value={9180} suffix=" zł" />
                      </div>
                      <p
                        style={{
                          fontSize: "14px",
                          margin: 0,
                          fontWeight: "500",
                          color: "#666",
                        }}
                      >
                        Miesięczne oszczędności
                      </p>
                    </Col>
                  </Row>

                  <div className="mt-auto text-end">
                    <Button
                      variant="outline-dark"
                      style={{
                        borderRadius: '10px',
                        padding: '8px 20px',
                        fontWeight: '600'
                      }}
                    >
                      Przeczytaj case study
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="text-center">
              <h3 className="mb-4" style={{ fontWeight: 'bold' }}>Chcesz osiągnąć podobne rezultaty?</h3>

              <div className="d-flex gap-3 justify-content-center flex-wrap" style={{ marginBottom: '24px' }}>
                <Button
                  onClick={handleRegisterClick}
                  style={{
                    backgroundColor: '#407EF9',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '16px 32px',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 14px rgba(64, 126, 249, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(64, 126, 249, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 14px rgba(64, 126, 249, 0.3)';
                  }}
                >
                  Wypróbuj za darmo
                </Button>

                <Button
                  onClick={() => window.open('https://calendly.com/krzysztof-warda-egodziny/30min', '_blank')}
                  style={{
                    backgroundColor: 'white',
                    color: '#1f2937',
                    border: '2px solid #e5e7eb',
                    borderRadius: '12px',
                    padding: '16px 32px',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.borderColor = '#407EF9';
                    e.target.style.color = '#407EF9';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.color = '#1f2937';
                  }}
                >
                  Umów bezpłatne demo
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}

export default CaseStudy;
